import {ApiClient} from '@hconnect/apiclient'
import type {User} from '@hconnect/common/types'
import {spawnErrorToast} from '@hm/fundamental'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../consts'

const QueryKey = 'created-by-search'
const CACHE_TIME_IN_MS = 1000 * 60

export const useCreatedBySearch = (
  namePattern: string | undefined,
  options?: Omit<UseQueryOptions<User[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const query = useQuery<User[], AxiosError>({
    queryKey: [QueryKey, namePattern],
    queryFn: async ({signal}) => {
      const path = `${TasksApiPath.TASKS}/creators`

      if (!namePattern) {
        return Promise.resolve([])
      }
      const response = await ApiClient.axiosInstance.get<User[]>(path, {
        params: {namePattern},
        signal
      })
      return response.data
    },
    gcTime: CACHE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })

  useEffect(() => {
    if (query.error) {
      spawnErrorToast(t('error.label.fetchingError'))
    }
  }, [query.error, t])

  return query
}
